import React, { Component } from "react"
import { withTranslation } from 'react-i18next';
import { GlobalContext } from "../../context/GlobalContext";
import { updateEmailAndCity } from "../../api/api"
import { Select } from "mobily-ui-library/lib";
import { getCities } from '../../api/api';
import Flag from 'react-world-flags';
import MapPin from "../../assets/MapPin.svg";

class EmailAndCityUpdate extends Component {
  static contextType = GlobalContext;
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      profileEmail: '',
      city: null,
      errors: {},
      cities: [],
      lineEmailStatus: "",
    }
  }

  componentDidMount = () => {
    this.getCitiesData()
  }

  getCitiesData = async () => {
    const [context] = this.context
    const { lang } = context
    const { contactInfo } = context.profileEnquiryResult
    const response = await getCities()
    const citiesList = JSON.parse(response?.data?.data?.cities)

    const cities = citiesList.map((c) => {
      return lang === "ar" ? {
        id: c.value,
        icon: <Flag className="" fallback={<img className="flagContainer" src={MapPin} alt={c.value} />} code={c.value} />,
        text: c.value_ar
      } : {
        id: c.value,
        icon: <Flag className="" fallback={<img className="flagContainer" src={MapPin} alt={c.value} />} code={c.value} />,
        text: c.value_en
      }
    });

    this.setState({
      cities,
      email: contactInfo.lineEmail,
      profileEmail: contactInfo.lineEmail,
      lineEmailStatus: contactInfo.lineEmailStatus
    })

  }

  handleEmailChange = (evt) => {
    this.setState({
      email: evt.target.value,
    });
  };

  onFocus = (event) => {
    event.target.setAttribute("autocomplete", "off");
  };

  handleSelectCity = (value) => {
    this.setState({ city: value })
  };

  filterOption = (input, option) => {
    return option.label.toLowerCase().includes(input.toLowerCase());
  };

  renderOption = (option) => {
    return (
      <div>
        <span>{option.label}</span>
        <span style={{ float: 'right', color: '#999' }}>{option.value}</span>
      </div>
    );
  };

  validateForm() {
    let errors = {};
    let formIsValid = true;
    const { email, city } = this.state

    if (!email) {
      formIsValid = false;
      errors["email"] = "email_required";
    }
    if (!city) {
      formIsValid = false;
      errors["city"] = "invalid_data";
    }

    this.setState({
      errors: errors,
    });

    return formIsValid;
  }

  handleEmailAndCityUpdate = async (e) => {
    e.preventDefault();
    if (this.validateForm()) {
      const { email, profileEmail, city, lineEmailStatus } = this.state;
      const [context, dispatch] = this.context;

      const emailUpdateResult = await updateEmailAndCity(email, city, true);
      const { data } = emailUpdateResult
      if (data.status.code === "MAPI-000") {
        dispatch({
          type: 'UPDATE_EMAIL_AND_CITY',
          payload: {
            email: email,
            otpType: "Email",
            hashCode: data.hashCode
          }
        })
        dispatch({
          type: 'GO_TO_SCREEN',
          payload: { profileUpdateScreen: "ActivationCodeScreen" }
        })
      }
      else {
        let errors = {};
        errors["customError"] = "invalid_data";
        this.setState({
          errors: errors,
        });
      }
    }
  }

  render() {
    const { t } = this.props;
    const { email, cities, city, errors } = this.state
    const [context] = this.context;
    const { lang, rtl, dir } = context

    return (
      <div className="auction-profile-update">
        <div className="pu_subheading">{t("email_notify_text")}</div>

        {errors.customError ? (
          <div className="alert alert-danger" role="alert">
            <b>
              {t(errors.customError)}{" "}
              <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
            </b>
          </div>
        ) : null}

        <div className={
          "form-group " + (errors.email ? "not-valid" : "")}>
          {/* <label className="pu-input-label">{t("useremail")}</label> */}
          <input
            type="text"
            className="form-control pu-input-field"
            placeholder={t("enter_your_email")}
            value={email}
            onChange={this.handleEmailChange}
            maxLength="50"
            onFocus={this.onFocus} />
          {this.state.errors.email ? (
            <div className="alert alert-danger" role="alert">
              {t(this.state.errors.email)}{" "}
              <i
                className="fa fa-exclamation-circle"
                aria-hidden="true"
              ></i>
            </div>
          ) : (
            <div className="empty-alert">&nbsp;</div>
          )}
        </div>
        <p>{t("email_text")}</p>

        <div className={
          "pu-dropdown-field " + (errors.city ? "not-valid" : "")}>
          <Select
            id="selectCountry"
            rtl={rtl}
            value={city}
            className="select_field"
            placeholder={t("select_a_city")}
            onChange={this.handleSelectCity}
            options={cities}
            showSearch={true}
          />
        </div>
        {this.state.errors.city ? (
          <div className="alert alert-danger" role="alert" style={{ "marginTop": "0px" }}>
            {t(this.state.errors.city)}{" "}
            <i
              className="fa fa-exclamation-circle"
              aria-hidden="true"
            ></i>
          </div>
        ) : (
          <div className="empty-alert">&nbsp;</div>
        )}
        <p className="pu-cityText">{t("city_text")}</p>

        <button id="emailUpdateButton" onClick={this.handleEmailAndCityUpdate}
          type="submit"
          name="email_update_button"
          className="btn min_outlin_btn active">
          {t("update")}{" "}
          <i className="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
        <p>{t("verification_code_text_email")}</p>

      </div>
    )
  }
}

export default withTranslation()(EmailAndCityUpdate);
